import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  eclipseDriveClientIcon,
  eclipseDriveLicenseIcon,
  eclipseDriveExtensionsIcon,
  eclipseDriveIncomeIcon,
  eclipseDriveArrowIcon,
} from 'assets/images';
import styles from './styles.module.scss';

const featureKeys = ['renewed', 'notReset', 'commissions'] as const;

export const WhatIsEclipseDriveSection = () => {
  const { t } = useTranslation('eclipseDrive');

  return (
    <div className={styles.section}>
      <div className={styles.section_content}>
        <h2 className={styles.section_title}>{t('whatIs.title')}</h2>
        
        <p className={styles.section_subtitle}>
          <span className={styles.subtitle_bold}>
            {t('whatIs.subtitleBold')}
          </span>
          <span className={styles.subtitle_regular}>
            {t('whatIs.subtitleRegular')}
          </span>
        </p>
        
        <div className={styles.flow_diagram}>
          <div className={styles.flow_item}>
            <div className={styles.flow_icon_wrapper}>
              <img
                src={eclipseDriveClientIcon}
                alt="Client"
                className={styles.flow_icon}
              />
              <span className={styles.flow_label}>{t('whatIs.flow.client')}</span>
            </div>
          </div>
          
          <img
            src={eclipseDriveArrowIcon}
            alt=""
            className={styles.arrow}
          />
          
          <div className={styles.flow_item}>
            <div className={styles.flow_icon_wrapper}>
              <img
                src={eclipseDriveLicenseIcon}
                alt="License"
                className={styles.flow_icon}
              />
              <span className={styles.flow_label}>{t('whatIs.flow.license')}</span>
            </div>
          </div>
          
          <img
            src={eclipseDriveArrowIcon}
            alt=""
            className={styles.arrow}
          />
          
          <div className={styles.flow_item}>
            <div className={styles.flow_icon_wrapper}>
              <img
                src={eclipseDriveExtensionsIcon}
                alt="Extensions"
                className={styles.flow_icon}
              />
              <span className={styles.flow_label}>{t('whatIs.flow.extensions')}</span>
            </div>
          </div>
          
          <img
            src={eclipseDriveArrowIcon}
            alt=""
            className={styles.arrow}
          />
          
          <div className={styles.flow_item}>
            <div className={styles.flow_icon_wrapper}>
              <img
                src={eclipseDriveIncomeIcon}
                alt="Income"
                className={styles.flow_icon}
              />
              <span className={styles.flow_label}>{t('whatIs.flow.income')}</span>
            </div>
          </div>
        </div>

        <div className={styles.features_container}>
          {featureKeys.map((key) => (
            <p
              key={key}
              className={styles.features_text}
            >
              • 
              {' '}
              {t(`whatIs.features.${key}`)}
            </p>
          ))}
        </div>
      </div>
    </div>
  );
};
